import React from 'react'
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { BiSearch, BiX } from "react-icons/bi";

import {
    clearExploreState,
    exploreMerchantKeyword
} from '../../../../application/actions/exploreActions';

import './SearchBar.css'
import {t} from '../../../../miscellaneous/language'

const MIN_SEARCH_LENGTH = 2;

const ExploreSearch = () => {
    const dispatch = useDispatch();
    const { isLoading, keyword } = useSelector((state) => ({
        isLoading: state.app.loading,
        keyword: state.explore.keyword
    }), shallowEqual);

    const [searchInput, setSearchInput] = React.useState(keyword || '');
    const lastSubmittedKeyword = React.useRef(keyword || '');

    React.useEffect(() => {
        if ((keyword || '') !== searchInput) {
            setSearchInput(keyword || '');
            lastSubmittedKeyword.current = keyword || '';
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [keyword]);

    const submitKeyword = React.useCallback((value) => {
        const nextKeyword = value.trim().toLowerCase();

        if (nextKeyword.length === 0) {
            lastSubmittedKeyword.current = '';
            dispatch(exploreMerchantKeyword(''));
            dispatch(clearExploreState());
            return;
        }

        if (
            nextKeyword.length < MIN_SEARCH_LENGTH ||
            nextKeyword === lastSubmittedKeyword.current
        ) {
            return;
        }

        lastSubmittedKeyword.current = nextKeyword;
        dispatch(exploreMerchantKeyword(nextKeyword));
    }, [dispatch]);

    const onSearchClick = () => {
        submitKeyword(searchInput);
    }

    const clearSearch = () => {
        setSearchInput('');
        submitKeyword('');
    }
    
    return (
        <div className="search-input-container search-form explore-search-form">
            <input 
                type="text" 
                className="search-input explore-search-box" 
                onChange={(e) => setSearchInput(e.target.value)}
                placeholder={t.placeholder.searchHome}
                readOnly={isLoading}
                value={searchInput}
                autoComplete="off"
                onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
            />
            {searchInput ? (
                <button className="search-clear-button" type="button" onClick={clearSearch} aria-label="Clear search">
                    <BiX size={22} />
                </button>
            ) : null}
            <button className="search-icon-button" type="button" onClick={onSearchClick} disabled={isLoading} aria-label="Search">
                <BiSearch size={23} color='white' />
            </button>
        </div>
    )
}

export default ExploreSearch
